const ENDPOINTS = {
  LOGIN: "/api/auth/login",
  SIGNUP: "/api/auth/signup",
  CATEGORIES: "/api/categories",
  PRODUCTS: "/api/products",
  CART:"/api/user/cart",
  CART_BULK:"/api/user/cart/bulk",
  WISHLIST:"/api/user/wishlist",
  WISHLIST_BULK:"/api/user/wishlist/bulk"
};

export default ENDPOINTS;
